import { ca } from '@cian/analytics';

export function trackJournalHighlightsView() {
  ca('eventSite', {
    name: 'oldevent',
    category: 'SeoBlock',
    action: 'show_main_link_sopr',
  });
}

export function trackJournalHighlightsClick(url: string) {
  ca('eventSite', {
    name: 'oldevent',
    category: 'SeoBlock',
    action: 'click_main_link_sopr',
    label: url,
  });
}
